// extracted by mini-css-extract-plugin
export var textInput = "_e3-0";